import { BaseCommand } from "./baseCommand";

export abstract class AbstractSearchDataCommand extends BaseCommand {
}